import { GLSL_ARG } from "../typeMapping";
export default [
    {
        name: "glsl",
        type: "code",
        codeType: "src",
        transform: code => [code || `return vec4(${GLSL_ARG.st}, 1.);`],
    },
    {
        name: "glslColor",
        type: "code",
        codeType: "color",
    },
    {
        name: "glslCoord",
        type: "code",
        codeType: "coord",
    },
    {
        name: "glslCombine",
        type: "code",
        codeType: "combine",
    },
    {
        name: "glslCombineCoord",
        type: "code",
        codeType: "combineCoord",
    },
];
